import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import CalendarPicker from '../util/CalendarPicker';
import { t } from 'i18next';
import moment from 'moment';
import UsersSalaryTable from '../financeComponents/UsersSalaryTable';
import CloseIcon from '@mui/icons-material/Close';
import DataSaverOnIcon from '@mui/icons-material/DataSaverOn';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DeleteModalAll from './DeleteModalAll';


interface TemporaryDrawerProps {
  selectedUser: any;
  refreshUsers: any;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function UserFenance({
  selectedUser,
  refreshUsers,
  setShow }: TemporaryDrawerProps) {
  const [userName, setUserName] = useState('');
  const [financeRow, setFinanceRow] = useState([]);
  const [userID, setUserID] = useState('');
  const [userLast, setUserLast] = useState('');
  const [userSecond, setUserSecond] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [salaryPerHour, setSalaryPerHour] = useState('');
  const [salaryPerHourNew, setSalaryPerHourNew] = useState('');
  const [patternHours, setPatternHours] = useState<number | null>(null);
  const [contractDate, setContractDate] = useState<any | null>(null);
  const [salaryDate, setSalaryDate] = useState<any | null>(null);
  const [contract, setContract] = useState<any | null>(null);
  const [contractAll, setContractAll] = useState<any | null>(null);
  const [openDel, setOpenDel] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    (async () => {
      if (selectedUser) {
        try {
          const { data } = await axios.get(`user/${selectedUser.id}`);
          const { data: Cont } = await axios.get(`hr-schedule-template`);
          if (Cont) {
            
            setContractAll(Cont);
          }
          if (data) {
            setUserSecond(data.second_name);
            setUserName(data.first_name);
            setUserLast(data.last_name);
            setJobTitle(data.job_title);
            setPatternHours(data.pattern?.hoursPerWeek ?? null);
            setSalaryPerHour(data.salary_perHour);
            setContractDate(data.contract_start_date);
            setContract(data.patternId);
            if (selectedUser) {
              setUserID(selectedUser.id)
            }
          }
        } catch (e) {
        }
      }
    })();
  }, [selectedUser]);

  const handleSelectChangeContract = (event: any) => {
    setContract(Number(event.target.value));
  };

  const handleDateContractChange = (date: Date) => {
    setContractDate(date);
  };

  const handSalary = (date: Date) => {
    setSalaryDate(date);
  };

  const handleInputChange = (e: any, setState: any, tire: any) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(new RegExp(`[^0-9${tire}.,]`, 'g'), '');
    inputValue = inputValue.replace(',', '.');
    const parts = inputValue.split('.');
    if (parts.length > 2) {
      inputValue = parts[0] + '.' + parts.slice(1).join('');
    }
    setState(inputValue);
  };

  const handleChange = async (userId: number) => {
    try {
      await axios.put(`update-user/${userId}`,
        {
          first_name: userName,
          last_name: userLast,
          second_name: userSecond,
          contract_start_date: contractDate,
          job_title: jobTitle,
          salary_perHour: Number(salaryPerHour),
          patternId: contract,
        });
      if (salaryPerHourNew !== '' && moment(salaryDate).isValid()) {
        const formattedDate = moment(salaryDate).format('DD.MM.YYYY');
        await axios.post(`finance/add`, {
          salary_perHour: Number(salaryPerHourNew),
          userId: Number(userID),
          startDate: formattedDate
        })
      }
      refreshUsers();
      setShow(false);
      enqueueSnackbar('User updated successfully', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Error updating user', { variant: 'error' });
      console.error('Error updating user:', error);
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (userID) {
          const { data } = await axios.get(`finance/user/${userID}`);
          setFinanceRow(data);
        }
      } catch (e) {
      }
    };
    checkAuth();
  }, [userID]);

  const refreshFinanceHistory = async () => {
    try {
      const { data } = await axios.get(`finance/user/${userID}`);
      setFinanceRow(data.length ? data : []);
      const { data: user } = await axios.get(`user/${selectedUser.id}`);
      if (user) {
        setSalaryPerHour(user.salary_perHour);
      }
    } catch (error: any) {
    }
  };

  const handleHistoryChange = async () => {
    try {
      if (salaryPerHourNew !== '' && moment(salaryDate).isValid()) {
        const formattedDate = moment(salaryDate).format('DD.MM.YYYY');
        await axios.post(`finance/add`, {
          salary_perHour: Number(salaryPerHourNew),
          userId: Number(userID),
          startDate: formattedDate
        })
      } else {
        enqueueSnackbar('Date or Salary did not use', { variant: 'error' });
        return
      }
      refreshUsers();
      refreshFinanceHistory();
      setSalaryDate('');
      setSalaryPerHourNew('');
      enqueueSnackbar('finance updated successfully', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Error updating user', { variant: 'error' });
      console.error('Error updating user:', error);
    }
  };

  const sortedFinanceRow = [...financeRow].sort((a: any, b: any) => {
    const dateA = a.startDate.split('.').reverse().join('-');
    const dateB = b.startDate.split('.').reverse().join('-');
    return new Date(dateA).getTime() - new Date(dateB).getTime();
  });

  return (
    <div className="fx-modal" role="presentation">
      {/* Header */}
      <div className="fx-head">
        <div className="fx-head-text">
          <div className="fx-head-title">{t('EditUser')}</div>
          <div className="fx-head-sub">{userName} {userLast} {userSecond}</div>
        </div>
        <div className="fx-close" onClick={() => setShow(false)}><CloseIcon fontSize="small" /></div>
      </div>

      {/* Body */}
      <div className="fx-body">
        <div className="fx-section">{t('Information')}</div>
        <div className="fx-row2">
          <div className="fx-field">
            <p className="fx-label">{t('HrWorkingPattern')}</p>
            <select
              className="fx-input"
              value={contract || 'none'}
              onChange={handleSelectChangeContract}>
              <option value="none">none</option>
              {contractAll?.map((contract: any) => (
                <option key={contract.id} value={contract.id}>
                  {contract.name}
                </option>))}
            </select>
          </div>
          <div className="fx-field">
            <p className="fx-label">{t('ContractStartDate')}</p>
            <CalendarPicker
              mode="single"
              variant="bare"
              className="fx-input"
              value={contractDate ? new Date(contractDate) : null}
              onChange={(date: any) => handleDateContractChange(date)}
              displayFormat="DD/MM/YYYY"
            />
          </div>
        </div>

        <div className="fx-row2">
          <div className="fx-field">
            <p className="fx-label">{t('ContractedHoursPerWeek')}</p>
            <div className="fx-input" style={{ background: 'var(--bg-disable)', color: 'var(--text-color-calendar-week)', cursor: 'default', display: 'flex', alignItems: 'center' }}>
              {patternHours != null ? `${patternHours} h` : '—'}
            </div>
          </div>
          <div className="fx-field">
            <p className="fx-label">{t('SalaryPerHours')}</p>
            <input type="text"
              className="fx-input"
              value={salaryPerHour ? salaryPerHour : ''}
              readOnly
              onChange={(e) => handleInputChange(e, setSalaryPerHour, '')} />
          </div>
        </div>

        <div className="fx-section">{t('AddNewSalary')}</div>
        <div className="fx-row2">
          <div className="fx-field">
            <p className="fx-label">{t('DateNewSalary')}</p>
            <CalendarPicker
              mode="single"
              variant="bare"
              className="fx-input"
              value={salaryDate ? new Date(salaryDate) : null}
              onChange={(date: any) => handSalary(date)}
              displayFormat="DD/MM/YYYY"
            />
          </div>
          <div className="fx-field">
            <p className="fx-label">{t('SalaryPerHours')}</p>
            <input type="text"
              className="fx-input"
              value={salaryPerHourNew ? salaryPerHourNew : ''}
              onChange={(e) => handleInputChange(e, setSalaryPerHourNew, '')} />
          </div>
        </div>
        <button type="button" className="fx-save" onClick={() => handleHistoryChange()}>
          <DataSaverOnIcon fontSize="small" /> {t('Add')}
        </button>

        <div className="fx-section" style={{ justifyContent: 'space-between' }}>
          <span>{t('History')}</span>
        </div>
        {financeRow.length > 0 && (
          <button type="button" className="fx-cancel" style={{ alignSelf: 'flex-start', color: '#ef4444', gap: 6 }} onClick={() => setOpenDel(true)}>
            <HighlightOffIcon fontSize="small" /> {t('RemoveAll')}
          </button>
        )}
        <UsersSalaryTable financeRow={sortedFinanceRow} />
      </div>

      {/* Footer */}
      <div className="fx-foot">
        <button type="button" className="fx-save" onClick={() => handleChange(selectedUser.id)}>
          {t('Change')}
        </button>
        <button type="button" className="fx-cancel" onClick={() => setShow(false)}>
          {t('Cancel')}
        </button>
      </div>

      {openDel && <DeleteModalAll
        open={openDel}
        setOpen={setOpenDel}
        refresh={refreshFinanceHistory}
        selectedDateId={selectedUser.id}
        typeName={'history'}
        typeBack={'finance'}
      />}
    </div>
  )
}